<div class="searchSmall container">
  <ng-container *ngIf="true">
    <form class="searchSmall__form" [formGroup]="advSearchForm" novalidate>
        <div class="searchSmall__wrap m-0">
          <div class="searchSmall__casualDating mr-3">
            <mat-radio-group aria-label="Select an option" class="" formControlName="casualDating">
              <mat-radio-button [value]="true" class="casualDating__option mr-2" color="primary">Casual Dating</mat-radio-button>
              <mat-radio-button [value]="false" class="casualDating__option" color="primary">Long Term</mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="searchSmall__relationship">
            <mat-select class="customized-select" placeholder="Relationship" formControlName="relationShips">
              <mat-option (click)="advSearchForm.controls.relationShips.reset()"></mat-option>
              <mat-option *ngFor="let sg of categories | async" [value]="sg.advertisementCategoryId">
                {{ sg.name }}
              </mat-option>
            </mat-select>
          </div>
          <div class="searchSmall__keywords ml-1">
            <input formControlName="keywords" class="customized-input" placeholder="Keywords" />
            <mat-checkbox class="searchSmall__withPics" formControlName="withPicturesOnly" labelPosition="before">With pics
            </mat-checkbox>
          </div>
          <div class="searchSmall__region" [hidden]="SearchType == SearchTypes.Zip">
            <mat-select class="customized-select" disableOptionCentering="true"
              placeholder="State" formControlName="region" (selectionChange)="setSelectedRegion($event.value)">
              <mat-select-trigger>
                {{ this.getRegionData(this.advSearchForm.controls["region"].value)?.shortName }}
              </mat-select-trigger>
              <mat-option>
                <ngx-mat-select-search  [placeholderLabel]="'State'" [noEntriesFoundLabel]="'No matching found'"
                  [formControl]="regionFilter"></ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let r of filteredRegions" [value]="r.regionId">
                {{ r.name }}
              </mat-option>
            </mat-select>
          </div>
          <div class="searchSmall__miles" [hidden]="SearchType == SearchTypes.City">
            <mat-select class="customized-select" placeholder="Miles"
              formControlName="miles">
              <mat-option *ngFor="let mile of miles" [value]="mile">
                  {{mile.viewValue}}
              </mat-option>
            </mat-select>
          </div>

          <div class="searchSmall__subregion ml-1" >
            <mat-select class="customized-select" disableOptionCentering="true"
              placeholder="City" formControlName="subregion" [hidden]="SearchType == SearchTypes.Zip">
              <mat-option>
                <ngx-mat-select-search #citySearchSelect [placeholderLabel]="'ex. Newport'" [noEntriesFoundLabel]="'No matching found'"
                  [formControl]="subregionFilter"></ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let r of filteredSubregion" [value]="r.subRegionId">
                {{ r.name }}
              </mat-option>
            </mat-select>
            <input [hidden]="SearchType == SearchTypes.City" formControlName="zipCode" class="w-100 customized-input"
              placeholder="From Zip Code" />
          </div>
          <div class="searchSmall__zipCitySwitch ml-2">
            <a href="#" (click)="changeSearchType($event)">switch
              {{this.SearchType == SearchTypes.Zip ? 'City' : 'Zip'}}</a>
          </div>
          <div class="searchSmall__btnSearch">
            <button [disabled]="loading || !this.regions || this.regions.length == 0" (click)="onSubmit(true, 'urlsearch')"
              class="search-btn" matTooltip="Search" mat-flat-button color="primary" type="submit">
              Search
            </button>
          </div>
        </div>
    </form>
  </ng-container>
</div>
